import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

export default function SupportForm({ collapsed }) {
  const [formData, setFormData] = useState({ subject: "", message: "" });
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I cancel my subscription?",
      answer:
        "You can cancel your subscription anytime from the billing section in your dashboard.",
    },
    {
      question: "How can I change my password?",
      answer:
        "Go to profile settings and click on 'Change Password' to update your credentials.",
    },
    {
      question: "Where can I see my past invoices?",
      answer:
        "Your billing history is available in the Billing section under Account settings.",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Support form submitted:", formData);
    // TODO: API call
  };

  return (
    <div
      className={`transition-all duration-300 ${
        collapsed ? "lg:ml-16" : "lg:ml-72"
      }`}
    >
      <div className="max-w-3xl mx-auto mt-12 p-6 bg-white border border-gray-200 shadow-sm rounded-xl space-y-12">
        {/* Support Form */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            Contact Support
          </h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label
                htmlFor="subject"
                className="block text-sm font-medium text-gray-700"
              >
                Subject
              </label>
              <input
                id="subject"
                name="subject"
                type="text"
                required
                value={formData.subject}
                onChange={handleChange}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                required
                value={formData.message}
                onChange={handleChange}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <button
              type="submit"
              className="w-full px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              Submit Request
            </button>
          </form>
        </div>

        {/* FAQ Section */}
        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Frequently Asked Questions
          </h3>
          <ul className="space-y-4">
            {faqs.map((faq, index) => (
              <li key={index} className="border border-gray-200 rounded-md">
                <button
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                  className="w-full flex justify-between items-center px-4 py-3 text-left text-sm font-medium text-gray-800 hover:bg-gray-50 focus:outline-none"
                >
                  <span>{faq.question}</span>
                  <ChevronDownIcon
                    className={`h-5 w-5 transform transition-transform duration-200 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-4 pb-4 text-sm text-gray-600">
                    {faq.answer}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
